<template>
  <div class="designer-list">
    <img src="@/assets/images/bg-mall-designer-list.png" alt="" class="top" />
    <div class="list-body">
      <div class="filter-box">
        <div class="left"></div>
        <div class="right">
          <Icon type="ios-search" size="22" class="search-icon" />
          <input type="text" v-model="query_form.keyword" @keyup.enter="onGetDesignerList" placeholder="按设计师名称搜索" />
          <div class="search-btn" @click="onGetDesignerList">搜索</div>
        </div>
      </div>
      <div class="list-container">
        <div
          class="designer-item"
          v-for="(item, index) in designer_list"
          :key="index"
          @click="$router.push({ name: 'ShopHome', query: { uid: item.code } })"
        >
          <div class="designer-info">
            <img
              :src="item.avatar | default_img"
              alt=""
              class="designer-cover"
            />
            <div class="designer-info-content">
              <div class="designer-name-box">
                <div class="designer-name">{{ item.nickname || "-" }}</div>
                <div class="follow-btn">
                  {{ item.is_followed ? "已关注" : "关注" }}
                </div>
              </div>
              <div class="designer-job-tags">{{ item.job }}</div>
              <div class="designer-desc">
                 {{ item.designer_introduction  || item.introduction ||''}}
              </div>
              <div class="designer-count-box">
                <div class="count-item">
                  <div class="count-num">{{ item.fans_count || 0 }}</div>
                  <div class="count-name">粉丝</div>
                </div>
                <div class="line-item"></div>
                <div class="count-item">
                  <div class="count-num">{{ item.works || 0 }}</div>
                  <div class="count-name">作品</div>
                </div>
                <div class="line-item"></div>
                <div class="count-item">
                  <div class="count-num">{{ item.zan_count || 0 }}</div>
                  <div class="count-name">获赞</div>
                </div>
              </div>
            </div>
          </div>
          <div class="designer-product-list">
            <div
              class="designer-product-item"
              v-for="(product, pi) in item.product"
              :key="pi"
              @click.stop="
                $router.push({
                  name: 'GoodsDetail',
                  params: { uuid: product.uuid },
                })
              "
            >
              <img
                :src="product.image | default_img"
                alt=""
                class="product-cover"
              />
              <div class="product-name">
                {{ product.name }}
              </div>
              <div class="product-price">¥{{ product.sale_price }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="page-container">
        <Page
          :total="total_count"
          prev-text="上一页"
          next-text="下一页"
          @on-change="onPageChange"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
import { designerList } from "@/api/index";
export default {
  data() {
    return {
      designer_list: [],
      total_count: 0,
      query_form:{page:1,limit:10,keyword:'',is_recommend:1}
    };
  },
  mounted() {
    if(this.$route.params.keyword){
        this.query_form.keyword = this.$route.params.keyword;
    }
    this.onGetDesignerList();
    this.$EventBus.$on('onHeaderSearch', (data) => {
        this.query_form.keyword = data?.keyword || '';
        this.query_form.page = 1;
        this.onGetDesignerList(); // 执行你的搜索方法
    });
  },
  beforeDestroy() {
      this.$EventBus.$off('onHeaderSearch');
  },
  beforeRouteEnter(to, from, next) {
        next((vm) => {
        // 通过 `vm` 访问组件实例
        vm.$emit("changeFooter", "mall");
        });
    },
  methods: {
    onPageChange(page) {
      console.log("page:", page);
      this.query_form.page = page;
      this.onGetDesignerList();
    },
    async onGetDesignerList() {
      try {
        const { code, msg, data } = await designerList(this.query_form);
        if (code > 1) {
          this.$layer.msg(msg);
          return;
        }
        this.total_count = data.count;
        this.designer_list = data.list;
        console.log("data->designer", data);
      } catch (e) {
        console.log("err-designer-list", e);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.designer-list {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 80px;
  .top {
    width: 100%;
    height: 360px;
  }
  .list-body {
    padding: 0 100px;
    display: flex;
    flex-direction: column;
    .filter-box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 25px;
      .left {
        display: flex;
        align-items: center;
        column-gap: 10px;
      }
      .right {
        width: 380px;
        height: 42px;
        border: 1px solid #cccccc;
        border-radius: 21px;
        display: flex;
        align-items: center;
        .search-icon {
          margin-left: 15px;
        }
        input {
          border: none;
          outline: none;
          width: calc(100% - 37px - 78px);
          padding:0 5px;
        }
        .search-btn {
          width: 72px;
          height: 32px;
          text-align: center;
          line-height: 32px;
          background: #1c1f23;
          border-radius: 16px;
          color: #ffffff;
          font-size: 14px;
        }
      }
    }
    .list-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-top: 24px;
      row-gap: 16px;

      .designer-item {
        width: 100%;
        background: #f5f5f5;
        padding: 25px 20px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        column-gap: 30px;

        &:hover {
          background: #ffffff;
          box-shadow: 0px 0px 13px 0px #e0e0e0;
        }

        .designer-info {
          display: flex;
          align-items: center;
          column-gap: 24px;

          .designer-cover {
            width: 250px;
            height: 314px;
            border-radius: 10px;
            object-fit: cover;
            object-position: center;
          }

          .designer-info-content {
            display: flex;
            flex-direction: column;
            // align-items:center;
            justify-content: space-between;
            width: 320px;
            height: 314px;
            // width: 100%;
            overflow: auto;
            flex-shrink: 0;

            .designer-name-box {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;

              .designer-name {
                color: #1a1a1a;
                font-size: 24px;
                font-weight: bold;
                white-space:nowrap;
                text-overflow: ellipsis;
                overflow:hidden;
              }

              .follow-btn {
                color: #ff5067;
                border: 1px solid #ff5967;
                border-radius: 8px;
                padding: 6px 15px;
                cursor: pointer;
                flex-shrink:0;
              }
            }

            .designer-job-tags {
              color: #666666;
              font-size: 14px;
              line-height: 36px;
            }

            .designer-desc {
              color: #1a1a1a;
              font-size: 14px;
              margin-top: 19px;
              line-height: 24px;
              display: -webkit-box;
              -webkit-line-clamp: 4;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .designer-count-box {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 63px;

              .count-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .count-num {
                  color: #ff5967;
                  font-size: 22px;
                  font-weight: bold;
                }

                .count-name {
                  color: #666666;
                  font-size: 14px;
                }
              }

              .line-item {
                width: 1px;
                height: 54px;
                background: #ebebeb;
              }
            }
          }
        }

        .designer-product-list {
          display: flex;
          align-items: center;
          column-gap: 10px;
          flex: 1;
          flex-shrink: 0;
          overflow-x: auto;
          overflow-y: visible;

          .designer-product-item {
            display: flex;
            flex-direction: column;
            // width: 200px;
            width: calc((100% - 10px) / 5);
            max-width: 200px;

            .product-cover {
              width: 100%;
              height: 260px;
              border-radius: 6px;
              background: #f5f5f5;
              border: 1px solid #e0e0e0;
              object-fit: contain;
            }

            .product-name {
              color: #333333;
              font-size: 14px;
              line-height: 35px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .product-price {
              color: #333333;
              font-size: 16px;
              font-weight: bold;
              // line-height: 16px; //>导致Mac下出现Y轴滚动
            }
          }
        }
      }
    }
    .page-container{
        width:100%;
        margin-top:93px;
        display:flex;
        align-items:center;
        justify-content:center;
    }
  }
}


@media screen and (min-width: 1280px) and (max-width: 1679px) {
  .designer-list {
    .list-body {
      padding: 0 60px;
      
      .filter-box {
        .right {
          width: 300px;
        }
      }
      
      .list-container {
        .designer-item {
          padding: 20px 15px;
          column-gap: 20px;
          
          .designer-info {
            column-gap: 20px;
            
            .designer-cover {
              width: 200px;
              height: 250px;
            }
            
            .designer-info-content {
              width: 280px;
              height: 250px;
              
              .designer-name-box {
                .designer-name {
                  font-size: 20px;
                }
              }
              
              .designer-desc {
                margin-top: 10px;
                -webkit-line-clamp: 3;
              }
              
              .designer-count-box {
                margin-top: 30px;
              }
            }
          }
          
          .designer-product-list {
            .designer-product-item {
              .product-cover {
                height: 200px;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1279px) {
  .designer-list {
    padding-bottom: 40px;
    
    .top {
      height: 200px;
    }
    
    .list-body {
      padding: 0 20px;
      
      .filter-box {
        margin-top: 15px;
        
        .right {
          width: 250px;
          height: 36px;
        }
        
        .search-icon {
          margin-left: 10px;
        }
        
        input {
          width: calc(100% - 30px - 60px);
        }
        
        .search-btn {
          width: 60px;
          height: 26px;
          line-height: 26px;
          border-radius: 13px;
          font-size: 12px;
        }
      }
      
      .list-container {
        margin-top: 15px;
        row-gap: 12px;
        
        .designer-item {
          padding: 15px;
          column-gap: 15px;
          
          .designer-info {
            column-gap: 15px;
            
            .designer-cover {
              width: 180px;
              height: 226px;
            }
            
            .designer-info-content {
              width: 220px;
              height: 226px;
              
              .designer-name-box {
                .designer-name {
                  font-size: 20px;
                }
              }
              
              .designer-job-tags {
                font-size: 12px;
                line-height: 28px;
              }
              
              .designer-desc {
                font-size: 12px;
                margin-top: 10px;
                line-height: 20px;
                -webkit-line-clamp: 3;
              }
              
              .designer-count-box {
                margin-top: 30px;
                
                .count-item {
                  .count-num {
                    font-size: 18px;
                  }
                  
                  .count-name {
                    font-size: 12px;
                  }
                }
                
                .line-item {
                  height: 40px;
                }
              }
            }
          }
          
          .designer-product-list {
            column-gap: 8px;
            
            .designer-product-item {
              .product-cover {
                height: 200px;
              }
              
              .product-name {
                font-size: 12px;
                line-height: 28px;
              }
              
              .product-price {
                font-size: 14px;
              }
            }
          }
        }
      }
      
      .page-container {
        margin-top: 40px;
      }
    }
  }
}
</style>
